import moment from "moment";
import ConnectionType from "./ConnectionType";
import ShProgressBar from "@/components/Helpers/ShProgressBar";
import ShTimeCounter from "@/components/Helpers/ShTimeCounter";
import ShTextWrapper from "@/components/Helpers/ShTextWrapper";
import AddressBookAddNewNumberForm from "@/components/AddressBook/AddressBookAddNewNumberForm";
import ShBooleanValueMapper from "@/components/Helpers/ShBooleanValueMapper";
import DashboardStatusIcon from "./DashboardStatusIcon";
import ForwardCallPopover from "../../ForwardCallPopover";
import PopoverSmsGateway from "@/components/Sms/PopoverSmsGateway";
import SurveyPopover from "@/components/Surveys/SurveyPopover";
import { hDeepCopy } from '@/utils/helpers';

// @vue/component
export default {
  name: "DashboardListItem",

  components: {
    ConnectionType,
    ShProgressBar,
    ShTimeCounter,
    ShTextWrapper,
    DashboardStatusIcon,
    ForwardCallPopover,
    ShBooleanValueMapper,
    PopoverSmsGateway,
    SurveyPopover,
    AddressBookAddNewNumberForm,
  },
  props: {
    connection: {
      type: Object,
      default: () => ({})
    },
    connectionTypeList: {
      type: Array,
      default: () => []
    },
    projectList: {
      type: Array,
      default: () => []
    },
    agentList: {
      type: Array,
      default: () => []
    },
    connectionStatusList: {
      type: Object,
      default: () => ({})
    },
    currentWiretappingId: {
      type: String,
      default: ""
    },
    stepDetails: {
      type: Array,
      default: () => [
        {
          step_name: "Brak informacji",
          step_color: "#787e84",
          step_icon: "#fas fa-question",
          step_description: "",
          step_key: "null",
          step_label: "Brak informacji"
        }
      ]
    },
    connectionWithOpenSurvey: {
      type: Number,
      default: null,
    }
  },
  data() {
    return {
      timeLeftForCalling: "0",
      currentTime: "",
      isVip: false,
      isWiretappingPopoverVisible: false,
      form: {
        agent: '',
      },
      isAddingRecordToPlanner: false,
      isAddPlannerRecordPopoverVisible: false,
      isSmsPopoverActive: false,
      selectedDate: '',
      note: '',
      isNotifyAllUsers: false,
      selectedSurvey: '',
      selectedTime: '',
      isManySurveyPopoverVisible: false,
      isSingleSurveyPopoverVisible: false,
      preparedAnswersForSurvey: [],
      isSurveyLoading: false,
      isAddingToAddressBook: false,

    };
  },

  computed: {
    projectDetails() {
      return this.projectList.filter(project => this.connection._project_id === project.id);
    },
    hasPermissionToAddNumber() {
      return this.$store.getters["authorization/acl"].hasPermission("allow_add_to_address_book_dashboard") && !this.connection._addressbookdescription;
    },
    selectedDateTime() {
      return `${this.selectedDate} ${this.selectedTime}:00`
    },
    surveysList() {
      return this.$store.getters['campaign/surveysList'];
    },
    currentCallSurvey() {
      return this.$store.getters['campaign/currentCallSurvey'];
    },
    questionsList() {
      return this.$store.getters['campaign/surveyQuestions'];
    },
    projectUuid() {
      return this.projectList.filter(project => this.connection._project_id === project.id)[0]
        ?.uuid;
    },
    isSmsGatewayVisible() {
      return (
        this.projectList.filter(project => this.connection._project_id === project.id).length > 0 &&
        this.connection._num_a.length === 11 &&
        this.connection._num_a.slice(0, 2) === "48"
      );
    },
    isLoading() {
      return this.$store.getters["global/pendingAsyncStoreActions"].includes([
        "dashboard/toggleWiretapping"
      ]);
    },
    isAgentAnswered() {
      return this.connection._answered_time !== null;
    },
    maxAgentTime() {
      // dodanie 4 sekund, poniewaz rozlaczenie nastepuje z opoznieniem
      return this.connection._ringing_time + 4;
    },
    separatedDigitMem() {
      let digits = this.connection._digit_mem.split("_").pop();
      let arrayOfDigits = [...digits];
      return arrayOfDigits.join(" >> ");
    },
    connectionStatusIcon() {
      return this.connectionStatusList[this.connection._full_stat][0].type_icon;
    },
    connectionStatusColor() {
      return this.connectionStatusList[this.connection._full_stat][0].type_color;
    },
    agent() {
      return this.agentList.find(agent => agent.id === this.connection._agent_id);
    },
    isAgentTalking() {
      return this.connection._agent_id === this.agent?.id;
    },
    agentsBelongsToUserList() {
      return this.$store.getters["user/agent/agentsBelongsToUserlist"].records;
    },
    currentWiretappingUuid() {
      return this.$store.getters["dashboard/wiretappingUuid"];
    },
    accessPlannerInDashboard() {
      return this.$store.getters["authorization/acl"].hasPermission("dashboard_callplanner_access");
    },
    accessSurveyForConnection() {
      return this.$store.getters["authorization/acl"].hasPermission("allow_fill_survey");
    },
    isSurveyPopoverLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'campaign/getSurveysList',
        'campaign/getSurveyQuestions'
      ]) || this.isSurveyLoading;
    },
    isAnyPopoverActive() {
      return this.isManySurveyPopoverVisible || this.isSingleSurveyPopoverVisible || this.isAddPlannerRecordPopoverVisible || this.isSmsPopoverActive;
    },
  },
  watch: {
    connection: {
      handler(newVal) {
        this.isVip = newVal._vip;
        this.setTimeLeftForCalling(newVal);
      }
    },
    deep: true,
    selectedDate: {
      handler() {
        if (!this.selectedDate) this.selectedDate = moment().format('YYYY-MM-DD');
      }
    },
    isAnyPopoverActive: {
      handler() {
        this.$emit('isAnyPopoverActive', this.isAnyPopoverActive);
      }
    },
    connectionWithOpenSurvey: {
      handler() {
        if (this.connectionWithOpenSurvey !== this.connection._id) {
          this.isManySurveyPopoverVisible = false;
          this.isSingleSurveyPopoverVisible = false;
        }
      }
    }
  },


  created() {
    this.isVip = this.connection._vip;
    this.isWiretappingPopoverVisible = false;
    this.setTimeLeftForCalling(this.connection);
    this.currentTime = moment().format();
    this.selectedDate = moment().format('YYYY-MM-DD');
  },
  methods: {
    handleIsSmsPopoverActive(value) {
      this.isSmsPopoverActive = value;
    },
    setTimeLeftForCalling(connection) {
      if (connection._calling_start !== null) {
        let nowTimestamp = moment();
        let startedConnectionTimestamp = moment(connection._calling_start);
        this.timeLeftForCalling = nowTimestamp.diff(startedConnectionTimestamp, "seconds");
      }
    },
    toggleVipStatus() {
      const wh1Uuid = this.connection._uuid;
      this.isVip = !this.isVip;
      this.$store.dispatch("dashboard/toggleVipStatus", {
        wh1Uuid,
        vip: this.isVip
      });
    },
    async toggleWiretapping() {
      const params = {
        connection: this.connection._uuid,
        agent: this.form.agent,
      };
      if (this.currentWiretappingUuid !== '') await this.disconnectWiretapping();
      await this.$store.dispatch("dashboard/toggleWiretapping", params);
      if (this.currentWiretappingUuid !== '')
        this.$message({
          type: 'success',
          message: "Za chwilę zadzwoni twój telefon. Strony rozmowy nie będą Ciebie słyszały.",
          duration: 3000,
        });
      this.$emit("setWiretappingUuid", this.currentWiretappingUuid);
    },
    async disconnectWiretapping() {
      await this.$store.dispatch("dashboard/disconnectWiretapping", {
        wiretapping: this.currentWiretappingUuid
      });
    },
    toggleWiretappingPopover() {
      this.form.agent = '';
      this.isWiretappingPopoverVisible = !this.isWiretappingPopoverVisible;
    },
    disconnectCall(wh1Uuid) {
      this.$store.dispatch("dashboard/disconnectCall", {
        wh1Uuid
      });
    },
    getLighterColor(colorValue) {
      const color = require("color");
      return color(colorValue).lighten(0.62);
    },
    getDarkenColor(colorValue) {
      const color = require("color");
      return color(colorValue).darken(0.07);
    },
    isAgentBelongsToUser() {
      if (this.agent) {
        return this.agentsBelongsToUserList.some(agent => agent.uuid === this.agent.uuid);
      }
      return false;
    },
    async addRecordToPlanner() {
      this.isAddingRecordToPlanner = true;
      const params = {
        project_uuid: this.connection._project_uuid,
        num_a: this.connection._num_a,
        call_stamp: this.selectedDateTime,
        note: this.note,
        notify_all_users: this.isNotifyAllUsers
      }
      const response = await this.$store.dispatch("callPlanner/addRecordToPlanner", params);
      if (response) {
        this.$message({
          title: 'Sukces',
          message: 'Dodano rekord do listy zaplanowanych połączeń.',
          type: 'success',
        });
        await this.$store.dispatch('callPlanner/getListCount');

      } else {
        this.$message({
          message: 'Wystąpił bład podczas dodawania do listy zaplanowanych połączeń.',
          type: 'error',
        });
      }
      this.isAddingRecordToPlanner = false;
    },
    clearForm() {
      this.isNotifyAllUsers = false;
      this.selectedDate = '';
      this.selectedTime = '';
      this.note = '';
    },
    handleGetSurveysList() {
      this.$emit('closeOtherSurveys', this.connection._id);
      this.isSingleSurveyPopoverVisible = true;
      this.getSurveysList();
    },
    async getSurveysList() {
      this.isSurveyLoading = true;
      await this.$store.dispatch('campaign/getSurveysList', this.connection._project_uuid);
      await this.$store.dispatch('campaign/getSurveyQuestionsForConnections', this.connection._uuid);
      if (this.currentCallSurvey.some(item => !!item._answer)) {
        const answersForSurveyCopy = hDeepCopy(this.currentCallSurvey);
        this.preparedAnswersForSurvey = answersForSurveyCopy.map(item => ({
          questionId: item._question_id,
          answer: item._answer
        }))
      }
      if (this.surveysList.length === 1) {
        this.selectedSurvey = this.surveysList[0].uuid;
        await this.$store.dispatch('campaign/getSurveyQuestions', this.surveysList[0].uuid);
      }
      this.isSurveyLoading = false;
    },
    async getSurveyQuestions() {
      await this.$store.dispatch('campaign/getSurveyQuestions', this.selectedSurvey);
    },
    async closeMultipleSurveyPopover() {
      this.isManySurveyPopoverVisible = false;
      await this.getSurveysList();
      this.selectedSurvey = '';
    },
    closeSingleSurveyPopover() {
      this.isSingleSurveyPopoverVisible = false;
    },
  }
};
